import { LookBook, LookBookItem, Media } from '@epicuro-next/models/engagement';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';
import { isBefore } from '@epicuro-next/utilities';
import { Dictionary } from '@ngrx/entity';

const shopTheLookModulePath = [
  APP_PRIVATE_PATHS.browse.path,
  APP_PRIVATE_PATHS.shopTheLook.path,
];

export function reorderSelectedLists(
  selectedLists: LookBookItem[],
  prevIndex: number,
  currentIndex: number,
): LookBookItem[] {
  const prevArray = [...selectedLists];
  const prevOrder = prevArray[prevIndex].order;
  const currentOrder = prevArray[currentIndex].order;

  prevArray[currentIndex] = {
    ...prevArray[currentIndex],
    order: prevOrder,
  };
  prevArray[prevIndex] = {
    ...prevArray[prevIndex],
    order: currentOrder,
  };
  return prevArray.sort((a, b) => a.order - b.order);
}

export function sortLookBookItems(
  selectedLists: LookBookItem[] = [],
): LookBookItem[] {
  return [...selectedLists]
    .map((item, index) => ({ ...item, order: index + 1 }))
    .sort((a, b) => a.order - b.order);
}

function getItemsToSend(items: LookBookItem[]) {
  return items.map(({ id, productListId, order }) => ({
    id,
    productListId,
    order,
  }));
}

export function adaptLookBookToSend(lookBook: LookBook) {
  const { id, title, items } = lookBook;
  return {
    id,
    title,
    lookBookItems: getItemsToSend(items),
  };
}

export function shopTheLookPath(paths: string[]) {
  return ['/', ...shopTheLookModulePath, ...paths];
}

export function lookBooksUpdateDateCompare(a: LookBook, b: LookBook) {
  return isBefore(new Date(a.updatedAt), new Date(b.updatedAt)) ? 1 : 0;
}

export function mapLookbookMediaEntities(
  entities: Dictionary<LookBook>,
  listId: string,
  media: Partial<Media>,
) {
  return Object.entries(entities).reduce((acc, [, value]) => {
    const items = value?.items.map((item) =>
      item.productList.id === listId
        ? {
            ...item,
            productList: {
              ...item.productList,
              media: [{ ...item?.productList?.media?.[0], ...media }],
            },
          }
        : item,
    );

    acc.push({ ...value, items } as LookBook);

    return acc;
  }, [] as LookBook[]);
}
